import appConfig from './appConfig';

// Core hosts shared routes (e.g. GET /tom_tom_key) outside the /kiosks namespace.
export const getRootApiURL = () => appConfig('VITE_API_SERVER').replace(/\/kiosks\/kiosks\/?$/, '');
